var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page gc" },
    [
      _c("SideMenu"),
      _vm._v(" "),
      _c("div", { staticClass: "page-content g9" }, [
        _c("h2", [_vm._v("Account")]),
        _vm._v(" "),
        _c(
          "form",
          {
            attrs: { action: "#", method: "post", id: "form" },
            on: { submit: _vm.onSubmit },
          },
          [
            _c("FormBuilder", {
              attrs: { formData: _vm.formData, formValue: _vm.member },
            }),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "right", class: { loading: _vm.isLoading } },
              [_vm._v("Save")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }